/** The Trustpilot page where a person writes a review of MUSIC24. */
export const TRUSTPILOT_REVIEW_URL = 'https://www.trustpilot.com/evaluate/music24.com';
